import {UIImage} from '../common/ui/uiImage';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import {UIScreen} from '../common/ui/uiScreen';
import {UIText} from '../common/ui/uiText';
import {Game} from './game';
import LevelsButton from './assets/levelsButton.json';
import { UIPanel } from '../common/ui/uiPanel';
import { Server } from '../../server/server';
import { getPortraitImage } from '../../app/util/util';

export class MapScreen extends UIScreen {

  userPortrait: UIImage;
  friendPortrait: UIImage[];
  background: UIPanel;
  scrollToBottomNextUpdate: boolean;

  public build() {
    this.background = new UIPanel({
      fitParent: {left: 0, right: 0, top: 0, bottom: 0},
      mouseEvents : true,
      clipChildren : true,
      scrollChildren : {horizontal : false, vertical : true},
      parent : this
    });

    this.scrollChild = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 100 * 81},
      parent: this.background
    })

    let props = this.setImageProps('null', 0, 0, 0);
    this.userPortrait = new UIImage(props);
  }

  public onWake() {
    // Server.user.deleteCookie('matcha-adventure')
    this.friendPortrait = [];
    this.scrollToBottomNextUpdate = true;
    this.buildButtons();
  }

  public async buildButtons() {
    let cookie = Game.instance.getAdventureCookie();
    let level  = cookie.level;
    console.log('onWake --> current level', level)

    let x = -80, y = 50;
    let rev = false;

    // for (let i = 0; i < LevelsButton.length; i++) {
    for (let i = 0; i < 100; i++) {
      rev ? x -= 80 : x += 80;
      y -= 80;
      if (x == 160)  rev = true;
      if (x == -160) rev = false;

      this.drawLevelButton(i + 1, x, y, level);
      // this.drawLevelButton(i + 1, LevelsButton[i].x, LevelsButton[i].y, level);
    }

    this.drawUserPortrait(level);
    this.drawFriendPortrait();
  }

  public update() {
    super.update();

    if (this.scrollToBottomNextUpdate) {
      let cookie = Game.instance.getAdventureCookie();
      let level  = cookie.level;

      this.background.scrollToBottom();
      let bottomY = this.background.scrollPosition.y;
      
      let moveY = bottomY + (level - 1) * 50;
      this.background.scrollPosition.y = moveY;
      this.scrollToBottomNextUpdate = false;
    }
  }

  private drawLevelButton(level: number, x: number, y: number, currentLevel: number) {
    let props  = this.setLevelProps(level, x, y);
    let button = new UIPanelButton(props);

    let txt_props = this.setLevelTextProps(level.toString(), button);
    let but_txt   = new UIText(txt_props);

    if (level > currentLevel)
      this.disableButton(button);
  }

  protected disableButton(level: UIPanelButton) {
    level.disabled = true;
    level.setDisabledColors('#00000020', '#00000020');
  }

  protected setLevelProps(level: number, x: number, y: number) {
    let data = {
      panelColors : {normal : '#16396f', hover : '#214783', pressed : '#2a518e'},
      radius : 30,
      borderWidth : 2,
      borderColor : '#000000',
      textColors : {normal : '#ffffff'},
      callback : () => {
        Game.instance.levelSelected = level;
        Game.instance.gameScreen.show();
      },
      anchor : {x : 0.5, y : 1},
      pivot : {x : 0.5, y : 1},
      size : {x : 70, y : 70},
      position : {x : x, y : y},
      parent : this.scrollChild 
    };

    return data;
  }

  protected setImageProps(url: string, x: number, y: number, size: number) {
    let data = {
      url : url,
      anchor : {x : 0.5, y : 1},
      pivot : {x : 0.5, y : 1},
      position : {x : x, y : y - 80},
      size : {x : size, y : size},
      stretch : true,
      parent : this.scrollChild
    };

    return data;
  }

  protected setLevelTextProps(level: string, parent: UIPanelButton) {
    let data = {
      text : level,
      fontFamily : 'verdana',
      fontSize : 28,
      fontWeight: '800',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      strokeLineWidth: 2,
      strokeColor: '#444000',
      color: '#FFF200',
      parent : parent
    };

    return data;
  }

  private drawUserPortrait(level: number) {
    let url = getPortraitImage(Server.user.getProfile());
    let props = this.setImageProps(url, LevelsButton[level - 1].x, LevelsButton[level - 1].y, 50);
    this.userPortrait.url = 'null';
    this.userPortrait = new UIImage(props);
  }

  private async drawFriendPortrait() {
    for (let i = 0; i < this.friendPortrait.length; i++)
      this.removeChild(this.friendPortrait[i]);

    let response = await Server.user.getFriendsCookie('matcha-adventure');
    let cookies = response.cookies; // Real data

    // fake data
    // let cookies = [
    //   {
    //     "user": "29cb7c27-0846-4746-9409-d0e2cd94c5f2",
    //     "value": "{\"level\":3,\"score\":28816}",
    //     "url": "/assets/portrait-basketball.png"
    //   },
    //   {
    //     "user": "29cb7c27-0846-4746-9409-d0e2cd94c5f2",
    //     "value": "{\"level\":2,\"score\":28816}",
    //     "url": "/assets/portrait-coffee.png"
    //   },
    //   {
    //     "user": "29cb7c27-0846-4746-9409-d0e2cd94c5f2",
    //     "value": "{\"level\":3,\"score\":28816}",
    //     "url": "/assets/portrait-fireworks.png"
    //   },
    //   {
    //     "user": "29cb7c27-0846-4746-9409-d0e2cd94c5f2",
    //     "value": "{\"level\":2,\"score\":28816}",
    //     "url": "/assets/portrait-island.png"
    //   },
    //   {
    //     "user": "29cb7c27-0846-4746-9409-d0e2cd94c5f2",
    //     "value": "{\"level\":3,\"score\":28816}",
    //     "url": "/assets/portrait-pyramids.png"
    //   },
    // ];

    let levels = new Map();
    for (let i = 0; i < cookies.length; i++) {
      let url = getPortraitImage(Server.public.getProfile(cookies[i].user));
      // let url = cookies[i].url; // temp code
      let val = JSON.parse(cookies[i].value);

      let num = levels.get(val.level);
      if (num)
        levels.set(val.level, num + 1);
      else {
        num = 0;
        levels.set(val.level, 1);
      }
      // console.log("cookiesuser", val, levels)

      let x = 60 + num * 25, y = 60;
      if (num < 4) {
        if (num == 3)
          url = '/assets/matcha-extra-turns.png';

        let props = this.setImageProps(
          url, 
          LevelsButton[val.level - 1].x + x, 
          LevelsButton[val.level - 1].y + y, 
          35
        );
  
        let portrait = new UIImage(props);
        this.friendPortrait.push(portrait);
      }
    }
  }
}